import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import NavbarRo from './components/NavbarRo';
import Footer from './components/Footer';
import FooterRo from './components/FooterRo';
import HomePage from './pages/HomePage';
import StoryPage from './pages/StoryPage';
import ChaptersPage from './pages/ChaptersPage';
import AuthorPage from './pages/AuthorPage';
import HomePageRo from './pages/ro/HomePageRo';
import StoryPageRo from './pages/ro/StoryPageRo';
import ChaptersPageRo from './pages/ro/ChaptersPageRo';
import AuthorPageRo from './pages/ro/AuthorPageRo';

const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

const AppRoutes = () => {
  const location = useLocation();
  const isRo = location.pathname.startsWith('/ro');

  return (
    <>
      {isRo ? <NavbarRo /> : <Navbar />}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* English routes */}
          <Route path="/" element={<PageWrapper><HomePage /></PageWrapper>} />
          <Route path="/story" element={<PageWrapper><StoryPage /></PageWrapper>} />
          <Route path="/chapters" element={<PageWrapper><ChaptersPage /></PageWrapper>} />
          <Route path="/author" element={<PageWrapper><AuthorPage /></PageWrapper>} />
          {/* Romanian routes */}
          <Route path="/ro" element={<PageWrapper><HomePageRo /></PageWrapper>} />
          <Route path="/ro/story" element={<PageWrapper><StoryPageRo /></PageWrapper>} />
          <Route path="/ro/chapters" element={<PageWrapper><ChaptersPageRo /></PageWrapper>} />
          <Route path="/ro/author" element={<PageWrapper><AuthorPageRo /></PageWrapper>} />
        </Routes>
      </AnimatePresence>
      {isRo ? <FooterRo /> : <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-brand-dark text-gray-200 font-sans selection:bg-brand-accent selection:text-brand-dark">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;